import TeamsEmpty from './TeamsEmpty';

export default TeamsEmpty;
